import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Cog = ({ className }) => (
    <svg
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
        xmlns="http://www.w3.org/2000/svg"
        width="20.8"
        height="20.8"
        viewBox="0 0 20.8 20.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.65"
    >
        <path
            d="M19.16,12.73l-2.32,4a2.91,2.91,0,0,0-2.79-.17,3.05,3.05,0,0,0-1.24,2.49H8.17a2.54,2.54,0,0,0-1-2.85,2.54,2.54,0,0,0-3,.52l-2.31-4s1.82-.74,1.8-2.27-1.8-2.37-1.8-2.37l2.33-4a2.9,2.9,0,0,0,3,.09,3,3,0,0,0,1-2.41h4.64s0,2,1.22,2.74,2.8-.41,2.8-.41l2.32,4a2.57,2.57,0,0,0-1.74,2.4A2.39,2.39,0,0,0,19.16,12.73Z"
            strokeLinejoin="bevel"
            strokeWidth="2.65"
        />
        <circle cx="10.4" cy="10.4" r="2.36" strokeMiterlimit="10" strokeWidth="2.65" />
    </svg>
);

Cog.propTypes = propTypes;
Cog.defaultProps = defaultProps;

export default Cog;
